import { createFileRoute, Navigate } from "@tanstack/react-router";
import { UsersOverviewPage } from "@/pages/users-overview/ui/users-overview-page";
import { useIsOwnerOrAdmin } from "@/entities/user/hooks/use-is-owner-or-admin";

const UsersOverviewRoute = () => {
  const { isOwnerOrAdmin } = useIsOwnerOrAdmin();

  // Redirect non-admin users
  if (!isOwnerOrAdmin) {
    return <Navigate to="/" replace />;
  }

  return <UsersOverviewPage />;
};

export const Route = createFileRoute(
  "/_authed/$companySlug/_settings/settings/users/",
)({
  component: UsersOverviewRoute,
});
